import $ from 'jquery';

$('.emp-tabs .nav-link').on('click', function () {
  const desiredPosition = $(this).data('desired-position');

  $('.desired-position').find('input').val(desiredPosition);
});
